// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1zwZA","inner":"Footer_inner__2X5Jc","nextIcon":"Footer_nextIcon__2F1sW","innerLeft":"Footer_innerLeft__2liBl"};